const imageSizes = {
    newsArticle: {
        width: 1920,
        height: 1080,
    },
    homePage: {
        bannerVideo: {
            launch: {
                width: 853,
                height: 480,
            },
            announcement: {
                width: 2500,
                height: 1016,
            },
            playgrounds: {
                width: 853,
                height: 480,
            },
        },
        featuresTile: {
            width: 550,
            height: 254,
        },
        buyNowSection: {
            background: {
                width: 2500,
                height: 1085,
            },
            mobileBackground: {
                width: 1000,
                height: 1000,
            },
            editionKeyart: {
                width: 827,
                height: 463,
            },
        },
        mediaSection: {
            screenshot: {
                width: 3814,
                height: 2160,
            },
        },
    },
    youtubeVideo: {
        width: 16,
        height: 9,
    },
};

export default imageSizes;
